<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <ProvideApiFilebank
    v-slot="{ uploadFiles, deleteFiles, deleting, uploading }"
    :default-tags="defaultTags"
    @uploaded="handleRecentlyUploadedFiles"
    @files-deleted="handleDeletedFiles"
    @update-busy-status="handleUpdatedBusyStatus"
  >
    <div>
      <div
        v-for="file of modelValue"
        :key="file.localId"
        class="clip-text nowrap p-b-5 tw-flex tw-items-center tw-justify-center"
      >
        <WdsStack justify-start align-center gap-sm>
          <FileIcon :icon="file.icon" size="sm" />
          <span v-if="!file.link">{{ file.name }}</span>
          <a v-else :href="file.link" target="_blank">{{ file.name }}</a>
          <WdsButtonIcon
            v-if="!disabled"
            transparent-background
            sm
            @click="deleteFiles([file.localId])"
          >
            <WdsIcon name="trash-can" size="14" />
          </WdsButtonIcon>
        </WdsStack>
      </div>
      <div v-if="showDuplicateFileWarning" class="alert alert-warning m-t-10" role="alert">
        {{ $t('Please avoid uploading duplicate files') }}
      </div>
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <PickerFileOs
        v-if="!disabled"
        :open-on-mounted="openOnMounted"
        :multiple="true"
        :disabled="uploading || deleting"
        :blocked-filenames="modelValue.map((file) => file.name)"
        class="m-t-10"
        :button-class="buttonClass"
        @duplicate-file-attempted="handleDuplicateFileAttempted"
        @files-selected="handleFilesSelected($event, uploadFiles)"
      >
        <template v-if="uploading || deleting">
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <button-spinner />
          {{ $t(uploading ? 'Uploading' : 'Removing') }}
        </template>
        <template v-else>
          {{ $t(modelValue.length ? 'Add files' : 'Choose files') }}
        </template>
      </PickerFileOs>
    </div>
  </ProvideApiFilebank>
</template>

<script>
import { WdsButtonIcon, WdsIcon, WdsStack } from '@worksome/wds-components'
import FileIcon from '@/components/FileIcon.vue'

export default {
  components: { FileIcon, WdsStack, WdsButtonIcon, WdsIcon },
  props: {
    modelValue: { type: Array, default: () => [] },
    defaultTags: { type: Array[String], default: () => [] },
    disabled: { type: Boolean, default: false },
    buttonClass: { type: String, default: 'btn btn-success' },
    openOnMounted: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedFileIds: [],
      showDuplicateFileWarning: false,
    }
  },
  methods: {
    handleRecentlyUploadedFiles(files) {
      this.$emit('update:modelValue', [...this.modelValue, ...files])
    },
    handleDeletedFiles(deletedFileIds) {
      // To update the v-model to only include non-deleted files
      this.$emit(
        'update:modelValue',
        this.modelValue.filter((file) => !deletedFileIds.includes(file.localId)),
      )
    },
    handleUpdatedBusyStatus(status) {
      this.$emit('update-busy-status', status)
    },
    handleDuplicateFileAttempted() {
      this.showDuplicateFileWarning = true
    },
    handleFilesSelected(event, uploadFiles) {
      this.showDuplicateFileWarning = false
      uploadFiles(event)
    },
  },
}
</script>
